import {combineReducers} from 'redux';

const stateDefaults = {
    online: [],
};

export default function onlineUsersReducer(state, action) {
    if (!state) {
        state = Object.assign({}, stateDefaults);
    }
    switch (action.type) {
        case 'SESSION_UPDATES':
            // console.log('store online user',action)
            state = Object.assign({}, state);
            state.online = action.updates.online;

            break;
    }

    return state;
}
